import React from 'react';
import PriceBoundsDropdown from './desktop-filter-dropdowns/PriceBoundsDropdown';
import BedsBathsDropdown from './desktop-filter-dropdowns/BedsBathsDropdown';
import HomeTypesDropdown from './desktop-filter-dropdowns/HomeTypesDropdown';
import MoreFiltersDropdown from './desktop-filter-dropdowns/MoreFiltersDropdown';
import LotStatusFilters from './LotStatusFilters';
import Button from 'common/components/Button';
import useFiltersStore from '../store/useFiltersStore';
import settings from '../util/config';
import { BUTTON_TYPES } from 'common/types/forms';
import Toggle from 'common/components/Toggle';
const DesktopFilterBar = () => {
    const { resetFilters } = useFiltersStore();
    const { quickMoveIn, setQuickMoveIn, setApplyFilterFlag } = useFiltersStore();
    return (React.createElement(React.Fragment, null,
        React.createElement(LotStatusFilters, null),
        React.createElement("fieldset", { className: "viewport-map__filters__filter-dropdowns" },
            React.createElement("legend", { className: "viewport-map__filters__heading" }, settings.FilterAvailableHomesLabel),
            React.createElement(PriceBoundsDropdown, null),
            React.createElement(BedsBathsDropdown, null),
            React.createElement(HomeTypesDropdown, null),
            React.createElement(MoreFiltersDropdown, null),
            React.createElement(Toggle, { toggleTitle: settings.QuickMoveInLabel, onChange: (value) => {
                    setQuickMoveIn(value);
                    setApplyFilterFlag(true);
                }, checked: quickMoveIn, renderSmall: true, className: "viewport-map__filters__quick-move-in" }),
            React.createElement(Button, { type: BUTTON_TYPES.BUTTON_LINK, className: "viewport-map__filters__reset-button", onCLick: () => resetFilters() }, settings.FilterResetLabel))));
};
export default DesktopFilterBar;
